import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import logExploreTrailCardListActionTaken from '@alltrails/amplitude/events/logExploreTrailCardListActionTaken';
import {
  updateAdminFilters,
  updateDistanceAway,
  updateExploreActionType,
  updateFilters,
  updateTrailEngagement
} from '@alltrails/explore-service/redux/exploreServiceSlice';
import { useExploreNullState } from '@/hooks/useExploreNullState';
import { useAppDispatch } from '@/utils/redux';
import ExploreNullState from '../ExploreNullState/ExploreNullState';

type NoResultsProps = {
  className?: string;
  expandable: boolean;
  hasFilters: boolean;
  onZoomOutClick: () => void;
};

const NoResults = ({ className, expandable, hasFilters, onZoomOutClick }: NoResultsProps) => {
  const dispatch = useAppDispatch();

  const onClearFilters = useCallback(() => {
    logExploreTrailCardListActionTaken({ action_taken: 'clear filters cta clicked' });
    dispatch(updateExploreActionType('clear filter'));
    dispatch(updateDistanceAway(undefined));
    dispatch(updateAdminFilters({}));
    dispatch(updateFilters({}));
    dispatch(updateTrailEngagement([]));
  }, [dispatch]);

  const onZoomOut = useCallback(() => {
    logExploreTrailCardListActionTaken({ action_taken: 'zoom out cta clicked' });
    dispatch(updateExploreActionType('expand search'));
    onZoomOutClick();
  }, [dispatch, onZoomOutClick]);

  const { messaging, ctas } = useExploreNullState(hasFilters, expandable, onClearFilters, onZoomOut);

  return (
    <ExploreNullState buttons={ctas} className={className} description={messaging} title={<FormattedMessage defaultMessage="No trail results" />} />
  );
};

export default NoResults;
